const _originals = new WeakMap()

export function filterRangeOptions(minEl, maxEl) {
  const minTs = minEl.tomselect
  const maxTs = maxEl.tomselect
  if (!minTs || !maxTs) return

  if (!_originals.has(minEl)) _originals.set(minEl, _snapshot(minTs))
  if (!_originals.has(maxEl)) _originals.set(maxEl, _snapshot(maxTs))

  const minVal = minEl.value === "" ? NaN : parseInt(minEl.value, 10)
  const maxVal = maxEl.value === "" ? NaN : parseInt(maxEl.value, 10)

  _rebuild(maxEl, maxTs, isNaN(minVal) ? null : (v => v >= minVal))
  _rebuild(minEl, minTs, isNaN(maxVal) ? null : (v => v <= maxVal))
}

function _snapshot(ts) {
  return Object.values(ts.options).map(o => ({ ...o }))
}

function _rebuild(el, ts, isValid) {
  const orig = _originals.get(el)
  if (!orig) return

  const currentVal = el.value
  const newOptions = []
  const validNums = []

  for (const o of orig) {
    const v = parseInt(o.value, 10)
    if (isValid === null || isNaN(v) || isValid(v)) {
      newOptions.push({ ...o })
      if (!isNaN(v)) validNums.push(v)
    }
  }

  ts.clear(true)
  ts.clearOptions()
  ts.addOptions(newOptions)
  ts.refreshOptions(false)

  if (currentVal !== "" && newOptions.some(o => String(o.value) === String(currentVal))) {
    ts.setValue(currentVal, true)
  } else if (currentVal !== "") {
    if (!validNums.length) { ts.clear(true); return }
    const currentNum = parseInt(currentVal, 10)
    const nearest = validNums.reduce((a, b) =>
      Math.abs(b - currentNum) < Math.abs(a - currentNum) ? b : a
    )
    ts.setValue(String(nearest), true)
  }
}
